export default __webpack_public_path__ + "static/media/1830.a863889c.png";